import moment from "moment-timezone";
import { replace as l_replace, eachRight as l_eachRight, split as l_split, last as l_last, get as l_get } from "lodash-es";

export function timeFormat(time, format = "H:i A") {
    return moment(time, "HH:mm:ss").format("LT");
}

/**
 * Convert UTC date to local date
 * @param {number} utc_date - UTC date
 * @param {boolean} time - Whether to include time
 * @returns {string} Local date
 */
export function dateFormatToLocal(utc_date, time = true) {
    const args = {
      year: "numeric",
      month: "short",
      day: "numeric"
    }
    if (time) {
      args.hour = "2-digit";
      args.minute = "2-digit";
      args.hour12 = true;
    }
    return new Date(utc_date).toLocaleDateString('en-US', args);
}

export function getHttpsUrl(url) {
    if ( !url ) {
        return '';
    }
    url = url.replace('http://', 'https://');
    if ( !url.includes('://') ) {
        url = 'https://' + url;
    }
    if ( url.length < 14 ) {
        return '';
    }
    return url.endsWith('/') ? url.slice(0, -1) : url;
}

export function dateFormat(
    date,
    from_format = "YYYY-MM-DD",
    to_format = "DD/MM/YYYY"
) {
    if (!date) {
        return "<i>N/A</i>";
    }
    if (locale == "en") {
        to_format = "MM/DD/YYYY";
    }
    return moment(date, from_format).format(to_format);
}

export function dateTimeHumanize(dateTime) {
    if (dateTime) {
        return moment(dateTime).fromNow();
    }
    return null;
}

export function dateTimeFormat(dateTime) {
    const from_format = "YYYY-MM-DD";
    let to_format = "DD/MM/YYYY hh:mm A";
    if (locale == "en") {
        to_format = "MM/DD/YYYY hh:mm A";
    }
    const client_tz = moment.tz.guess() ? moment.tz.guess() : SERVER_TZ;
    return moment.tz(dateTime, client_tz).format(to_format);
}

function addZeroes(num) {
    num = typeof num == "number" ? num.toString() : num;
    const dec = num.split(".")[1];
    const len = 2;
    return Number(num).toFixed(len);
}

export function getItemCost(basePrice, disType, disValue) {
    let discountAmount = 0;
    discountAmount =
        disType == "percentage" ? basePrice * (disValue / 100) : disValue;
    if (basePrice - discountAmount < 0) {
        return '0.00';
    }
    return addZeroes(basePrice - discountAmount);
}

export function openWindowWithPost(url, data, target = "_blank") {
    const dataForm = document.createElement("form");
    dataForm.style.display = "none";
    dataForm.target = target; //Make sure the window name is same as this value
    dataForm.method = "POST";
    dataForm.action = url;
    for (const key in data) {
        const postData = document.createElement("input");
        postData.type = "hidden";
        postData.name = key;
        postData.value = data[key];
        dataForm.appendChild(postData);
    }
    document.body.appendChild(dataForm);
    dataForm.submit();
}

export const trans = (string, args) => {
    let value = l_get(window.i18n, string);

    const defaultVal = l_last(l_split(string, "."));
    if (value) {
        l_eachRight(args, (paramVal, paramKey) => {
            value = l_replace(value, `:${paramKey}`, paramVal);
        });
    } else {
        value = defaultVal;
    }
    return value;
};

export const transChoice = (string, args) => {
    const value = l_get(window.i18n, string);
    if (!value) return l_last(l_split(string, "."));

    const count = args[Object.keys(args)[0]]; // Get the count value dynamically
    const segments = value.split('|');

    let selectedSegment = '';
    for (const segment of segments) {
        const [condition, translation] = segment.trim().split(/\s(.+)/);
        if (condition.startsWith('[')) {
            const [min, max] = condition.slice(1, -1).split(',').map(val => val === '*' ? val : Number(val));
            if (count >= min && (max === '*' || count <= max)) {
                selectedSegment = translation;
                break;
            }
        } else if (condition.startsWith('{')) {
            const exactCount = Number(condition.slice(1, -1));
            if (count === exactCount) {
                selectedSegment = translation;
                break;
            }
        } else {
            selectedSegment = segment;
        }
    }

    if (!selectedSegment) {
        selectedSegment = segments[segments.length - 1];
    }

    // Replace all placeholders in the translation
    Object.keys(args).forEach(key => {
        selectedSegment = selectedSegment.replace(`:${key}`, args[key]);
    });

    return selectedSegment.trim();
};

export const editSnapshotFormData = (snapshot) => {
    const bodyFormData = new FormData();
    bodyFormData.append('launch_version', snapshot.is_monetized ? 'v2' : snapshot.launch_version);
    bodyFormData.append('name', snapshot.name);
    bodyFormData.append('slug', snapshot.slug);
    bodyFormData.append('description', (snapshot.display_text ?? ''));
    bodyFormData.append('active', snapshot.active);
    bodyFormData.append('mark_as_public', ((snapshot.mark_as_public == 1 || snapshot.mark_as_public == true) ? 'true' : 'false'));
    bodyFormData.append('email_required', snapshot.email_required ? 'true' : 'false');
    bodyFormData.append('collect_email', snapshot.collect_email ? 'true' : 'false');
    bodyFormData.append('collect_name', snapshot.collect_name ? 'true' : 'false');
    bodyFormData.append('send_credentials', snapshot.send_credentials ? 'true' : 'false');
    bodyFormData.append('hide_privacy_checkbox', snapshot.hide_privacy_checkbox ? 'true' : 'false');
    bodyFormData.append('disallow_file_modification', snapshot.disallow_file_modification ? 'true' : 'false');
    bodyFormData.append('auto_launch', snapshot.auto_launch ? 'true' : 'false');
    bodyFormData.append('site_cloning', snapshot.site_cloning ? 'true' : 'false');
    bodyFormData.append('redirect_url', snapshot.redirect_url ? snapshot.redirect_url : '');
    bodyFormData.append('site_life_time', snapshot.site_life_time);
    bodyFormData.append('sync_emails_to', snapshot.sync_emails_to);
    bodyFormData.append('instant_template', snapshot.instant_template ? 'true' : 'false');
    bodyFormData.append('custom_email_subject', snapshot.custom_email_subject);
    bodyFormData.append('custom_email_body', snapshot.custom_email_body);
    bodyFormData.append('custom_privacy_text', snapshot.custom_privacy_text);
    bodyFormData.append('custom_css', snapshot.custom_css);
    bodyFormData.append('zapier_webhook_url', snapshot.zapier_webhook_url ? snapshot.zapier_webhook_url : '');
    bodyFormData.append('post_creation_command', snapshot.post_creation_command ? snapshot.post_creation_command : '');
    bodyFormData.append('logo_file_name', snapshot.logo_file_name);
    bodyFormData.append('custom_primary_color', snapshot.custom_primary_color ? snapshot.custom_primary_color : '#15b881');
    bodyFormData.append('custom_accent_color', snapshot.custom_accent_color ? snapshot.custom_accent_color : '#ffffff');
    bodyFormData.append('hosting_account_id', snapshot.hosting_account_id ? snapshot.hosting_account_id : '');
    bodyFormData.append('server_type', snapshot.server_type ? snapshot.server_type : 'instawp_serve');
    bodyFormData.append('is_my_hosting', snapshot.is_my_hosting ? snapshot.is_my_hosting : 'false');
    bodyFormData.append('hosting_account_site_default_values', snapshot.hosting_account_site_default_values ? snapshot.hosting_account_site_default_values : []);

    return bodyFormData;
};

export const editTemplateFormData = (template) => {
    const bodyFormData = new FormData();
    bodyFormData.append('launch_version', template.is_monetized ? 'v2' : template.launch_version);
    bodyFormData.append('name', template.name);
    bodyFormData.append('slug', template.slug);
    bodyFormData.append('description', (template.display_text ?? ''));
    bodyFormData.append('active', template.active);
    bodyFormData.append('mark_as_public', ((template.mark_as_public == 1 || template.mark_as_public == true) ? 'true' : 'false'));
    bodyFormData.append('email_required', template.email_required ? 'true' : 'false');
    bodyFormData.append('collect_email', template.collect_email ? 'true' : 'false');
    bodyFormData.append('collect_name', template.collect_name ? 'true' : 'false');
    bodyFormData.append('send_credentials', template.send_credentials ? 'true' : 'false');
    bodyFormData.append('hide_privacy_checkbox', template.hide_privacy_checkbox ? 'true' : 'false');
    bodyFormData.append('disallow_file_modification', template.disallow_file_modification ? 'true' : 'false');
    bodyFormData.append('auto_launch', template.auto_launch ? 'true' : 'false');
    bodyFormData.append('site_cloning', template.site_cloning ? 'true' : 'false');
    bodyFormData.append('redirect_url', template.redirect_url ? template.redirect_url : '');
    bodyFormData.append('site_life_time', template.site_life_time);
    bodyFormData.append('sync_emails_to', template.sync_emails_to);
    bodyFormData.append('instant_template', template.instant_template ? 'true' : 'false');
    bodyFormData.append('custom_email_subject', template.custom_email_subject);
    bodyFormData.append('custom_email_body', template.custom_email_body);
    bodyFormData.append('custom_privacy_text', template.custom_privacy_text);
    bodyFormData.append('custom_css', template.custom_css);
    bodyFormData.append('zapier_webhook_url', template.zapier_webhook_url ? template.zapier_webhook_url : '');
    bodyFormData.append('post_creation_command', template.post_creation_command ? template.post_creation_command : '');
    bodyFormData.append('logo_file_name', template.logo_file_name);
    bodyFormData.append('custom_primary_color', template.custom_primary_color ? template.custom_primary_color : '#15b881');
    bodyFormData.append('custom_accent_color', template.custom_accent_color ? template.custom_accent_color : '#ffffff');
    bodyFormData.append('hosting_account_id', template.hosting_account_id ? template.hosting_account_id : '');
    bodyFormData.append('server_type', template.server_type ? template.server_type : 'instawp_serve');
    bodyFormData.append('is_my_hosting', template.is_my_hosting ? template.is_my_hosting : 'false');
    bodyFormData.append('hosting_account_site_default_values', template.hosting_account_site_default_values ? template.hosting_account_site_default_values : []);

    return bodyFormData;
};

export const readableFileSize = (size) => {
    const i = size == 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));
    return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'KB', 'MB', 'GB', 'TB'][i];
}

export const setObjectProperty = (object, path, value) => {
    const parts = path.split('/');
    const limit = parts.length - 1;
    for (let i = 0; i < limit; ++i) {
        const key = parts[i];
        object = object[key] ?? (object[key] = {});
    }
    const key = parts[limit];
    object[key] = value;
};

export const humanizeNumbers = (num, digits = 1) => {
    const lookup = [
        { value: 1, symbol: "" },
        { value: 1e3, symbol: "k" },
        { value: 1e6, symbol: "M" },
        { value: 1e9, symbol: "G" },
        { value: 1e12, symbol: "T" },
        { value: 1e15, symbol: "P" },
        { value: 1e18, symbol: "E" }
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    const item = lookup.slice().reverse().find(function (item) {
        return num >= item.value;
    });
    return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0"
}

export const setCanonicalUrl = (url) => {
    const link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', url);
    document.head.appendChild(link);
}

export function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
export function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}
export function eraseCookie(name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

export const calculateFileSize = (number) => {
    if (number === 0) {
        return '0 Bytes';
    }
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(number) / Math.log(k));
    return parseFloat((number / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}

export function getExpiryPercentage(expiredAt, allowedDays) {
    const expiryDate = moment.utc(expiredAt, 'YYYY-MM-DD HH:mm:ss');
    const nowUtc = moment.utc();

    // Calculate the difference in milliseconds
    const diffInMs = expiryDate.diff(nowUtc);
    const totalAllowedTimeInMs = allowedDays * 24 * 60 * 60 * 1000;

    // Calculate the percentage
    const percentage = (diffInMs / totalAllowedTimeInMs) * 100;

    // Ensure the percentage is not less than 0 or more than 100
    const validPercentage = Math.max(0, Math.min(percentage, 100));

    return 100 - validPercentage;
}

export function versionCompare(v1, v2, operator) {
    if (!v1 || !v2) {
        return false;
    }
    const compareVersions = (v1, v2) => {
        const v1Parts = v1.split('.').map(Number);
        const v2Parts = v2.split('.').map(Number);
        const length = Math.max(v1Parts.length, v2Parts.length);

        for (let i = 0; i < length; i++) {
            const v1Part = v1Parts[i] || 0;
            const v2Part = v2Parts[i] || 0;

            if (v1Part > v2Part) return 1;
            if (v1Part < v2Part) return -1;
        }

        return 0;
    };

    const comparison = compareVersions(v1, v2);

    switch (operator) {
        case '>':
            return comparison > 0;
        case '>=':
            return comparison >= 0;
        case '<':
            return comparison < 0;
        case '<=':
            return comparison <= 0;
        case '==':
        case '=':
        case 'eq':
            return comparison === 0;
        case '!=':
        case '<>':
        case 'ne':
            return comparison !== 0;
        default:
            throw new Error(`Invalid operator: ${operator}`);
    }
}

export function utcToHumanize(dateTime, timezone = null) {
    if (!dateTime) {
        return null;
    }

    // Parse the input datetime as UTC
    let utcMoment = moment.utc(dateTime);

    // If a timezone is provided, convert to that timezone
    if (timezone) {
        utcMoment = utcMoment.tz(timezone);
    } else {
        // If no timezone is provided, use the client's local timezone
        utcMoment = utcMoment.local();
    }

    const now = moment();

    let result;
    if (utcMoment.isSame(now, 'day')) {
        // If it's today, return humanized string
        result = utcMoment.fromNow();
    } else {
        // If not today, return formatted date and time in 24-hour format
        result = utcMoment.format('DD-MM-YYYY HH:mm');
    }

    // Capitalize the first letter
    return result.charAt(0).toUpperCase() + result.slice(1);
}

export function usedPercentage(key, used, allow) {
    if (used[key] < 0) {
        return 0;
    }

    if (!isNaN(allow[key]) && !isNaN(used[key])) {
        return Math.round(
            (used[key] * 100) / allow[key]
        );
    }
    return 0;
}

export function isPlanLimitOver(features, can) {
    let is_over = false
    features.forEach(function (feature) {
        if (can.hasOwnProperty(feature.key) && can[feature.key] === false) {
            is_over = true;
            //ignore warning for a teams members count
            if (feature.key == 'team_member' || feature.key == 'live_credits') {
                is_over = false;
            }
        }
        //
    });
    return is_over;
}

export function numberShortFormatter(num, digits) {
    const lookup = [
        { value: 1, symbol: "" },
        { value: 1e3, symbol: "k" },
        { value: 1e6, symbol: "M" },
        { value: 1e9, symbol: "G" },
        { value: 1e12, symbol: "T" },
        { value: 1e15, symbol: "P" },
        { value: 1e18, symbol: "E" }
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    const item = lookup.slice().reverse().find(function (item) {
        return num >= item.value;
    });
    return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
}

export function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

export function getURLParams(key) {
    const uri = window.location.search.substring(1);
    const params = new URLSearchParams(uri);
    return params.get(key)
}

export function cdn(fileurl) {
    let url = fileurl
    if (url.match(/^http[s]{0,1}:/g)) {
        return url
    }

    if (!url.match(/^[/]/)) {
        url = '/' + url
    }

    let app_env = import.meta.env.VITE_APP_ENV;
    if (app_env == 'local' || app_env == 'develop') {
        return url
    }

    if (app_env == 'staging') {
        return  'https://app-instawp-staging.b-cdn.net' + url
    }

    return 'https://cdn.instawp.io' + url
}

export const tagColours = [
    '#854d0e',
    '#9d174d',
    '#ffa500',
    '#92400e',
    '#065f46',
    '#155e75',
    '#9f1239',
    '#008000',
    '#4b0082',
    '#065f46',
    '#5b21b6',
    '#991b1b',
    '#1e40af',
    '#ffd045',
];

export function getClientReferenceId() {
    return window.Rewardful && window.Rewardful.referral || ('checkout_' + (new Date).getTime());
}


export const showRemainingDays = (remainingMinutes) => {
    if (isNaN(remainingMinutes) || remainingMinutes < 0) {
        return 'Invalid input';
    }

    const duration = moment.duration(remainingMinutes, 'minutes');
    const days = duration.days();
    const hours = duration.hours();
    const minutes = duration.minutes();

    let result = `${days > 0 ? `${days} day${days > 1 ? 's' : ''}` : ''}`;
    result += hours > 0 ? ` ${hours} hour${hours > 1 ? 's' : ''}` : '';
    result += minutes > 0 ? ` ${minutes} minute${minutes > 1 ? 's' : ''}` : '';

    return result.trim() || "0 minutes";
}

// Utility function to convert Laravel :param format to Vue {param} format
function convertLaravelToVueFormat(translations) {
    const converted = {};
    
    function processValue(value) {
        if (typeof value === 'string') {
            // Replace Laravel :parameter with Vue {parameter}
            return value.replace(/:(\w+)/g, '{$1}');
        } else if (typeof value === 'object' && value !== null) {
            return processObject(value);
        }
        return value;
    }
    
    function processObject(obj) {
        const result = Array.isArray(obj) ? [] : {};
        
        for (const key in obj) {
            result[key] = processValue(obj[key]);
        }
        
        return result;
    }
    
    return processObject(translations);
}